import { PermissionKeyFormat, RBAC } from '~/services/rbac';
import { isAdmin, isOwner } from '~/services/rbac/helpers';

export const IMAGE_PERMISSIONS = {
  EDIT: 'images.edit',
  EDIT_OWN: 'images.edit:own',
  FEATURE: 'images.feature',
} as const satisfies Record<string, PermissionKeyFormat<'images'>>;

export type ImagePermission =
  (typeof IMAGE_PERMISSIONS)[keyof typeof IMAGE_PERMISSIONS];

export const COMMENT_PERMISSIONS = {
  DELETE: 'comments.delete',
  DELETE_OWN: 'comments.delete:own',
  DELETE_IMAGE_OWNER: 'comments.delete:imageOwner',
} as const satisfies Record<string, PermissionKeyFormat<'comments'>>;

export type CommentPermission =
  (typeof COMMENT_PERMISSIONS)[keyof typeof COMMENT_PERMISSIONS];

export function registerGalleryPolicies(rbac: RBAC<GalleryImage>) {
  // Images
  rbac.allowPermission(IMAGE_PERMISSIONS.EDIT_OWN, isOwner);
  rbac.allowPermission(IMAGE_PERMISSIONS.FEATURE, isAdmin);

  // Comments
  rbac.allowPermission(COMMENT_PERMISSIONS.DELETE_OWN, isOwner);
  rbac.allowPermission(
    COMMENT_PERMISSIONS.DELETE_IMAGE_OWNER,
    ({ user, resource: comment }) => {
      return !!(
        comment?.image &&
        !!('user' in comment?.image) &&
        (comment.image.user as User).id === user?.id
      );
    }
  );
}
